<app-page-content>
<app-doenkids-menu-bar menuBar [loading]="loading$ | async">
  <div left class="left">
    @if (!showRevokedTemplates.value && !(showMobileSearchBar$ | async)) {
      <app-activity-search-bar
        [query]="currentSearchParams?.query"
        [contentLanguage]="currentSearchParams?.language"
        (searched)="searchEventHappened($event)"
        [showContentLanguageOption]="!(baseOnly$ | async)"
      ></app-activity-search-bar>
    }
  </div>

  <div right>
    <form class="form-wrapper">
      @if (!showRevokedTemplates.value) {
        <span class="new-folder-checkbox">
          @if ((isAdmin$ | async) || ((hasProgramTemplateCreatePermission$ | async) && !(baseOnly$ | async))) {
            <mat-checkbox
              [formControl]="selectProgramsCtrl"
              color="primary"
              >
              {{ 'program_templates.bundle.create.label' | translate }}
            </mat-checkbox>
          }
          @if (selectProgramsCtrl.value === true) {
            <button
              [disabled]="($programTemplateSelection.programTemplates$ | async)?.length < 2"
              mat-icon-button
              type="button"
              (click)="createProgramTemplateBundle()"
              [matTooltip]="'program_templates.bundle.create.label' | translate"
              >
              <mat-icon>create_new_folder</mat-icon>
            </button>
          }
        </span>
      }
      <app-responsive-toolbar-content
        class="filter-container"
        icon="filter_list"
        [isOpen]="toolBarContentOpen | async"
        tooltip="program_templates.responsive_toolbar.tooltip"
        (toolBarMenuOpen)="updateToolbarMenuOpen($event)"
        >
        <ng-template #content>
          @if ((okoTypes$ | async)?.length > 0) {
            <mat-form-field appearance="outline" class="oko-selector">
              <mat-select [formControl]="typeOko">
                @for (okoType of okoTypes$ | async; track okoType) {
                  <mat-option [value]="okoType.id">{{ okoType.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if ((baseOnly$ | async) && searchQueryCtrl.value?.query === '') {
            <mat-form-field appearance="outline" class="revoked-selector">
              <mat-select [formControl]="showRevokedTemplates">
                <mat-option [value]="false">
                  {{ 'program_templates.revoked.to_review.label' | translate }}
                </mat-option>
                <mat-option [value]="true">
                  {{ 'program_templates.revoked.label' | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if (!(baseOnly$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
            <app-program-template-status
              [currentStatus]="currentPublicationStatus"
              (change)="changePublicationStatus($event)"
              [additionalStatuses]="additionalProgramStatuses"
            ></app-program-template-status>
          }
        </ng-template>
      </app-responsive-toolbar-content>
    </form>
  </div>
</app-doenkids-menu-bar>
<div content>
  @if (!showRevokedTemplates.value && (showMobileSearchBar$ | async)) {
    <div class="mobile-search-bar">
      <app-activity-search-bar
        [query]="currentSearchParams?.query"
        [contentLanguage]="currentSearchParams?.language"
        (searched)="searchEventHappened($event)"
        [showContentLanguageOption]="!(baseOnly$ | async)"
      ></app-activity-search-bar>
    </div>
  }

  <div class="main-content" [ngClass]="{ triggeredSearch: (triggerSearchView$ | async) }">
  @if (triggerSearchView$ | async) {
    <div class="search-results">
      <div class="category-title">
        <h2>{{ 'program_templates.search_result.heading' | translate }}</h2>
      </div>
      <div class="horizontal-container">
        @if ((programTemplateSearch$ | async).length === 0) {
          <h3>{{ 'program_templates.no_results' | translate }}</h3>
        }
        @for (template of programTemplateSearch$ | async; track template) {
          <div (click)="handleProgramTemplateClick($event, template)" class="search-card">
            <app-doenkids-image
              [preview]="true"
              [class.selected]="(selectedTemplates$ | async) && (selectedTemplates$ | async)[template.id]"
              [mediaItem]="template.media_uuid"
              [maxWidth]="200"
            ></app-doenkids-image>
            <img class="checked" src="./assets/images/selected-icon.png" />
          </div>
        }
      </div>
    </div>
  }

  @if (!(triggerSearchView$ | async)) {
    @for (category of categorizedProgramTemplates$ | async; track category) {
      <div class="template-overview flex-col">
        @if (category.templates.length > 0 || (category.bundles.length > 0 && !(onlyTemplates$ | async))) {
          <div class="category-title">
            <h2>{{ category.name }}</h2>
            @if (
              !showRevokedTemplates.value &&
              category.id &&
              (category.templates.length > 1 || category.bundles.length > 1) &&
              ((isAdmin$ | async) || category.isOfOwner)
              ) {
              <button
                mat-icon-button
                type="button"
                (click)="goToReOrderCategory(category)"
                [matTooltip]="'program_templates.category.reorder.tooltip' | translate"
                >
                <mat-icon>view_list</mat-icon>
              </button>
            }
          </div>
        }
        @if (category.templates.length > 0) {
          <div class="vertical-container flex-col items-stretch" style="flex: 1 1 50%;">
            <swiper-container class="swiper-container flex-auto" dkSwiper [config]="swiperConfig" init="false">
              @for (item of category.templates; track item) {
                <swiper-slide (click)="handleProgramTemplateClick($event, item)" class="swiper-slide">
                  <app-doenkids-image
                    [preview]="true"
                    [class.selected]="(selectedTemplates$ | async) && (selectedTemplates$ | async)[item.id]"
                    [mediaItem]="item.media_uuid"
                    [maxWidth]="200"
                  ></app-doenkids-image>
                  <img class="checked" src="./assets/images/selected-icon.png" />
                </swiper-slide>
              }
            </swiper-container>
          </div>
        }
        @if (category.bundles.length > 0 && !(onlyTemplates$ | async)) {
          <div class="vertical-container flex-col items-stretch" style="flex: 1 1 50%;">
            <swiper-container class="swiper-container flex-auto" dkSwiper [config]="swiperConfig" init="false">
              @for (item of category.bundles; track item) {
                <swiper-slide (click)="handleProgramTemplateBundleClick(item)" class="swiper-slide paper">
                  <app-doenkids-image
                    [preview]="true"
                    [class.selected]="(selectedTemplates$ | async) && (selectedTemplates$ | async)[item.id]"
                    [mediaItem]="item.media_uuid"
                    [maxWidth]="200"
                  ></app-doenkids-image>
                  <img class="checked" src="./assets/images/selected-icon.png" />
                </swiper-slide>
              }
            </swiper-container>
          </div>
        }
      </div>
    }
    @if ((categorizedProgramTemplates$ | async)?.length === 0) {
      <app-empty-page-message
        [message]="'program_templates.no_templates' | translate"
        icon="file_copy"
      ></app-empty-page-message>
    }
  }
  </div>
</div>
</app-page-content>
